import React from 'react'
import PropTypes from 'prop-types'
import { formatNumber } from '@engine/utils/format'
import Checkbox from '@material-ui/core/Checkbox'
import DeleteIcon from '@material-ui/icons/Delete'
import DragIndicatorIcon from '@material-ui/icons/DragIndicator'
import './EditUnitMixRow.scss'

const EditUnitMixRow = props => {
  const { row, index, unitMixCount, unitmix_attr_to_be_displayed, onDragOver, onDragStart, onDrop, handleRowSelection, selectedRows, onDelete, isLastRec } = props
  const [hoverd, setHovered] = React.useState(false)

  const handleChange = event => {
    handleRowSelection(event.target.value)
  }

  return (
      <div
        data-testid={`edit-unit-mix-row-${index}`}
        onDragOver={onDragOver(index)}
        onDragStart={onDragStart(index)}
        onDrop={onDrop(index)}
        // onDragLeave={e => this.clearSelection(e)}
        draggable={true}
        className={`edit-unit-mix-row ${index >= unitMixCount ? 'outOfLimit' : ''}`}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
          {unitmix_attr_to_be_displayed.map((key, idx) => {
            let rowElement = ''
            if (idx === 0) {
              rowElement = <React.Fragment key={idx}>
                <div className="drag-and-checkbox">
                  <DragIndicatorIcon style={{ color: '#757575' }}/>
                  <Checkbox
                    checked={selectedRows?.includes(index)}
                    onChange={handleChange}
                    color="primary"
                    inputProps={{ 'aria-label': 'secondary checkbox', 'data-testid': `unitmix-row-${index}` }}
                    value={index}
                  />
                </div>
                <div className="data-text">{formatNumber(key, row[key])}</div></React.Fragment>
            } else if (idx === unitmix_attr_to_be_displayed.length - 1) {
              rowElement = <React.Fragment key={idx}>
              <div className="data-text">{formatNumber(key, row[key])}</div>
              {hoverd ? (
                <DeleteIcon data-testid="btn-delete" className={isLastRec ? 'disabled-icon' : 'delete-icon'} onClick={() => onDelete(index)} />
              ) : null }
            </React.Fragment>
            } else {
              rowElement = <div key={idx} className="data-text">{formatNumber(key, row[key])}</div>
            }

            return rowElement
          })}
        </div>
  )
}

EditUnitMixRow.propTypes = {
  handleRowSelection: PropTypes.func,
  onDragOver: PropTypes.func,
  onDragStart: PropTypes.func,
  onDrop: PropTypes.func,
  row: PropTypes.object,
  index: PropTypes.number,
  unitMixCount: PropTypes.number,
  unitmix_attr_to_be_displayed: PropTypes.array,
  onDelete: PropTypes.func,
  isLastRec: PropTypes.bool,
  selectedRows: PropTypes.array
}

export default EditUnitMixRow
